var exports = {
  "kL": "x61f99309--86991b--container",
  "kb": "x61f99309--86991b--left",
  "pG": "x61f99309--86991b--right",
  "fP": "x61f99309--86991b--attention",
  "Qq": "x61f99309--86991b--text",
};

module.exports = exports;
